export default (contacto = {}) => {
  return {
    ...contacto,
    // @ts-expect-error TS(2339): Property 'impuestosCompra' does not exist on type ...
    impuestosCompra: contacto?.impuestosCompra || {
      repercutidoId: "",
      retenidoId: "",
    },
    // @ts-expect-error TS(2339): Property 'impuestosVenta' does not exist on type '...
    impuestosVenta: contacto?.impuestosVenta || {
      repercutidoId: "",
      retenidoId: "",
    },
  }
}
